// extracted by mini-css-extract-plugin
module.exports = {"learningPaths":"LearningPaths_learningPaths__3Ga5w","learningPathCard":"LearningPaths_learningPathCard__21wgr"};